// extracted by mini-css-extract-plugin
export default {"tableSize":"styles_tableSize__BKWKL"};